import { Component, Input } from '@angular/core';
import { IEmployee } from '../employee';
export class OrgChartComponent {
	 topEmployee: IEmployee;
	 hasManager = false;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
	selector: 'ng2-org-chart',
	template: "<oc-employee *ngIf=\"topEmployee\" [employee]=\"topEmployee\" [hasManager]=\"hasManager\"></oc-employee> <div class=\"oc-reports\"> <ng-container *ngFor=\"let employee of topEmployee?.subordinates; first as isFirst; last as isLast\"> <div class=\"oc-org-container\"> <div class=\"oc-h-bar-container\"> <div class=\"oc-h-bar oc-border\" [style.border-color]=\"isFirst?'transparent':''\"></div> <div class=\"oc-border\"></div> <div class=\"oc-h-bar oc-border\" [style.border-color]=\"isLast?'transparent':''\"></div> </div> <ng2-org-chart [topEmployee]=\"employee\" [hasManager]=\"true\"></ng2-org-chart> </div> </ng-container> </div> ",
	styles: [":host { display: flex; flex-direction: column; align-items: center; } .oc-reports { display: flex; flex: 1; } .oc-org-container { display: flex; flex-direction: column; } .oc-h-bar-container { display: flex; } .oc-h-bar { flex: 1; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'topEmployee': [{ type: Input },],
'hasManager': [{ type: Input },],
};
}

function OrgChartComponent_tsickle_Closure_declarations() {
/** @type {?} */
OrgChartComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OrgChartComponent.ctorParameters;
/** @type {?} */
OrgChartComponent.propDecorators;
/** @type {?} */
OrgChartComponent.prototype.topEmployee;
/** @type {?} */
OrgChartComponent.prototype.hasManager;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
